export default __webpack_public_path__ + "static/media/Polygon_dark.32fc2fab.svg";